import React from 'react';

import TOTPForm from '../../../../../components/forms/verifyTOTP';
import SuccessStep from './components/SuccessStep';
import useAuthAppTOTPForm from './hooks/useAuthAppTOTPForm';
import useFetchInitialCreds from './hooks/useFetchInitialCreds';

function EnableTOTP2FA({ onDecline }: { onDecline: () => void }) {
	const { handleDownloadFile, handleEnableTOTP2FA, backupCodes, formik } = useAuthAppTOTPForm();
	const { initialStringCode, initialQrCode, isInitialLoading } = useFetchInitialCreds();

	return backupCodes ? (
		<SuccessStep
			handleDownloadFile={handleDownloadFile}
			handleEnableMfa={handleEnableTOTP2FA}
			backupCodes={backupCodes}
			onDecline={onDecline}
		/>
	) : (
		<TOTPForm
			initialStringCode={initialStringCode}
			isInitialLoading={isInitialLoading}
			initialQrCode={initialQrCode}
			onDecline={onDecline}
			formik={formik}
			title="QR Code"
		/>
	);
}

export default EnableTOTP2FA;
